/** @jsxImportSource @emotion/react */

'use client';
import { Box, Paper, type SxProps } from '@mui/material';
import type { MouseEventHandler, ReactNode } from 'react';

import * as styles from './styles';

interface Props {
  disabled?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  size?: 'small' | 'medium';
  sx?: SxProps;
  placeholder?: string;

  onClick?: MouseEventHandler<HTMLDivElement>;

  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  children: ReactNode;
  error?: boolean;
}

export default function InputFieldValueMock({
  disabled,
  variant,
  size,
  error,
  sx,
  onClick,
  startAdornment,
  endAdornment,
  children,
}: Props) {
  return (
    <Paper
      sx={sx}
      css={[
        styles.inputFieldContainer,
        {
          small: styles.small,
          medium: styles.medium,
        }[size || 'small'],
        ...(!variant || variant === 'standard' ? [styles.standard] : []),
        ...(variant === 'outlined' ? [styles.outlined] : []),
        ...(variant === 'filled' ? [styles.filled] : []),
        ...(variant && variant !== 'standard' && startAdornment ? [styles.startAdornment] : []),
        ...(variant && variant !== 'standard' && endAdornment ? [styles.endAdornment] : []),
        ...(disabled ? [styles.disabled] : []),
        ...(error ? [styles.error] : []),
      ]}
      className={[variant ?? 'standard', ...(disabled ? ['disabled'] : [])].join(' ')}
      elevation={0}
      onClick={onClick}
    >
      {startAdornment}
      <Box
        css={styles.inputFieldContainerContent}
        className="inputFieldContainerContent"
      >
        {children}
      </Box>
      {endAdornment}
    </Paper>
  );
}
